// This function is used directly in the initial html and cannot rely on any polyfills.
export function checkIgnore(isUncaught: boolean, args: Array<any>, payload: any) {
  const regexsToIgnore = [
    /Branch init failed/gi,
    /GoogleAPI.*popup_closed_by_user/gi, // google auth
    /GoogleAPI.*popup_blocked_by_browser/gi, // google auth
    /GoogleAPI.*access_denied/gi, // google auth
    /unhandled rejection was null or undefined/gi,
    /script error/gi,
    /object Object/gi,
    /GraphQL error: 503/gi,
    /GraphQL error: Unauthorized/gi,
    /GraphQL error: Unauthorised/gi,
    /GraphQL error: No autorizado/gi,
    /GraphQL error: Não autorizado/gi,
    /GraphQL error: Non autorisé/gi,
    /GraphQL error: Internal service error/gi,
    /GraphQL error: 401/gi,
    /Network error: Failed to fetch/gi,
    // prettier-ignore
    /\$ is not defined/gi, // eslint-disable-line
    /Blocked a frame with origin "https:\/\/www.remind.com" from accessing a frame with origin "https:\/\/accounts.google.com". Protocols, domains, and ports must match./gi, // error with chrome on ios. Verified that it works correctly.
    /event is not defined/gi,
    /Failed to load because no supported source was found./gi,
    /maxItems has been hit. Ignoring errors until reset./gi, // When rollbar's max items per browser session have been hit
    /Cannot read property 'load' of undefined/gi, // chrome 47 auth
    /Not a Product/gi, // https://rollbar.com/Remind/r101-frontend/items/24611/
    /^Not Found$/i,
    /Appboy cannot be loaded - this is usually due to strict corporate firewalls or ad blockers/gi,
    /_isMatchingDomain is not defined/gi,
    /Failed to update a ServiceWorker.*A bad HTTP response code \(404\) was received when fetching the script/gi,
    /Rollbar:/gi,
    /Extension context invalidated/gi,

    // ONLY IGNORE THESE IF WE HAVE ENABLED LOAD SHEDDING:
    // /AdminAutoMessagesView/gi,
    // /PeopleListTableDataContainer/gi,
    // /Red Toast/gi,
  ];
  try {
    if (payload.fingerprint) {
      // eslint-disable-next-line
      for (var i = 0; i < regexsToIgnore.length; i++) {
        if (payload.fingerprint.search(regexsToIgnore[i]) !== -1) {
          return true;
        }
      }
      return false;
    }
    return false;
  } catch (e) {
    // if we did this wrong, lets log it so we can track why, and send the error anyway.
    console.error(e);
    return false;
  }
}

// This function is used directly in the initial html and cannot rely on any polyfills.
export function transform(payload: any) {
  // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'input' implicitly has an 'any' type.
  const idx = function (input, accessor) {
    try {
      return accessor(input);
    } catch (e) {
      return undefined;
    }
  };
  const message =
    // @ts-expect-error ts-migrate(7006) FIXME: Parameter '_' implicitly has an 'any' type.
    idx(payload, (_) => _.body.message.body) ||
    // @ts-expect-error ts-migrate(7006) FIXME: Parameter '_' implicitly has an 'any' type.
    idx(payload, (_) => _.body.message) ||
    // @ts-expect-error ts-migrate(7006) FIXME: Parameter '_' implicitly has an 'any' type.
    idx(payload, (_) => _.body.trace.exception.message) ||
    // @ts-expect-error ts-migrate(7006) FIXME: Parameter '_' implicitly has an 'any' type.
    idx(payload, (_) => _.body.trace.extra.extraArgs[0].message) ||
    // @ts-expect-error ts-migrate(7006) FIXME: Parameter '_' implicitly has an 'any' type.
    idx(payload, (_) => _.body.trace.extra.extraArgs[1].message) ||
    // @ts-expect-error ts-migrate(7006) FIXME: Parameter '_' implicitly has an 'any' type.
    idx(payload, (_) => _.body.trace.extra.extraArgs[0]) ||
    // @ts-expect-error ts-migrate(7006) FIXME: Parameter '_' implicitly has an 'any' type.
    idx(payload, (_) => _.body.trace.extra.extraArgs[1]);

  const description =
    // @ts-expect-error ts-migrate(7006) FIXME: Parameter '_' implicitly has an 'any' type.
    idx(payload, (_) => _.body.trace.exception.description) ||
    // @ts-expect-error ts-migrate(7006) FIXME: Parameter '_' implicitly has an 'any' type.
    idx(payload, (_) => _.body.message.extra.error);

  if (typeof message === 'string' && message !== '') {
    const shouldAddDescription =
      typeof description === 'string' &&
      description !== message &&
      description.indexOf('cloudfront.net') < 0;
    payload.fingerprint = message + (shouldAddDescription ? ` ${description || ''}` : '');
  } else if (description && typeof description === 'string') {
    payload.fingerprint = description;
  }
}

export function initConsoleError() {
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'Rollbar' does not exist on type 'Window ... Remove this comment to see the full error message
  if (typeof window !== 'undefined' && window.Rollbar) {
    // TODO some way to disable console output. This seems to require a PR to rollbar's lib.
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'Rollbar' does not exist on type 'Window ... Remove this comment to see the full error message
    const { Rollbar } = window;
    const nativeConsoleError = console.error;
    console.error = (...args) => {
      // If there's an error passed to the console, we want to use thar directly to preserve the stacktrace
      const hasError = args.some((e) => e instanceof Error);
      if (hasError) {
        Rollbar.error(...args);
      } else {
        // otherwise generate a stack trace
        try {
          throw Error(args[0]);
        } catch (e) {
          Rollbar.error(e, ...args.slice(1));
        }
      }
      return nativeConsoleError.apply(console, args);
    };

    Rollbar.global({
      maxItems: 10,
    });
  }
}

export function configureRollbar(user: { id: number }): void {
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'Rollbar' does not exist on type 'Window ... Remove this comment to see the full error message
  const { Rollbar } = window;
  if (Rollbar) {
    Rollbar.configure({
      payload: {
        person: {
          id: String(user.id),
        },
      },
    });
  }
}
